// boards.js - Shared board/curriculum constants
// Used by AITutorApp.js curriculum picker and onboarding BoardStep

export const CURRICULA = [
  "anatomy",
  "cbse",
  "igcse",
  "saras",
  "ap",
  "ngss_hs",
  "lnc",
  "ucsd"
];
// Board metadata for display in onboarding
export const BOARD_METADATA = {
  anatomy: {
    label: 'Anatomy',
    fullName: 'Human Anatomy',
    description: 'Specialized anatomy curriculum',
    icon: 'human',
    region: 'Universal',
  },
  cbse: {
    label: 'CBSE',
    fullName: 'Central Board of Secondary Education',
    description: 'Indian national curriculum',
    icon: 'school',
    region: 'India',
  },
  igcse: {
    label: 'Cambridge',
    fullName: 'Cambridge IGCSE',
    description: 'Cambridge international curriculum',
    icon: 'earth',
    region: 'International',
  },
  ngss_hs: {
    label: 'NGSS',
    fullName: 'Next Generation Science Standards (High School)',
    description: 'US national science standards',
    icon: 'flask',
    region: 'USA',
  },
  ap: {
    label: 'AP',
    fullName: 'Advanced Placement',
    description: 'College-level courses',
    icon: 'certificate',
    region: 'USA',
  },
  saras: {
    label: 'SARAS',
    fullName: 'SARAS Curriculum',
    description: 'SARAS educational standards',
    icon: 'book-education',
    region: 'India',
  },
  lnc: {
    label: 'LNC',
    fullName: 'LNC Curriculum',
    description: 'LNC educational standards',
    icon: 'book-open-variant',
    region: 'Universal',
  },
  ucsd: {
    label: 'Remedial Program',
    fullName: 'Remedial Curriculum',
    description: 'UCSD Math & Physics remedial prerequisites',
    icon: 'school',
    region: 'USA - UCSD',
  },
};

// BDD 02/15/2026
export const getBoardLabel = (id) => {
  return BOARD_METADATA?.[id]?.label || (id ? id.toUpperCase() : "");
};

// Helper to get boards with metadata for UI display
export const getBoardsWithMetadata = () => {
  return CURRICULA.map(id => ({
    id,
    ...BOARD_METADATA[id],
  }));
};

export const DEFAULT_BOARD = 'anatomy';
